export default "__VITE_ASSET__GEGovo6I__"